import { NgModule } from '@angular/core';

import { ProgressBarComponent } from './progress-bar.component';

@NgModule({
  declarations: [ProgressBarComponent],
  exports: [ProgressBarComponent],
})
export class ProgressBarModule {}
export { ProgressBarComponent } from './progress-bar.component';
